import {
  EquipmentMasterListStateTypes,
  EquipmentMasterListActionTypes,
} from "./EquipmentMasterList.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EquipmentMasterListStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EquipmentMasterListReducer = (
  state: EquipmentMasterListStateTypes = INITIAL_STATE,
  action: any
): EquipmentMasterListStateTypes => {
  switch (action.type) {
    case EquipmentMasterListActionTypes.FETCH_ALL_EQUIPMENT_MASTER_LIST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentMasterListActionTypes.FETCH_ALL_EQUIPMENT_MASTER_LIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EquipmentMasterListActionTypes.FETCH_ALL_EQUIPMENT_MASTER_LIST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentMasterListActionTypes.FETCH_ALL_EQUIPMENT_MASTER_LIST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EquipmentMasterListActionTypes.FETCH_ONE_EQUIPMENT_MASTER_LIST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EquipmentMasterListActionTypes.FETCH_ONE_EQUIPMENT_MASTER_LIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case EquipmentMasterListActionTypes.FETCH_ONE_EQUIPMENT_MASTER_LIST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EquipmentMasterListActionTypes.FETCH_ONE_EQUIPMENT_MASTER_LIST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EquipmentMasterListReducer;
